export default __webpack_public_path__ + "2f0d4657fff0241a7239ee6ab95bc0f2.svg";